import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { numberWithCommas } from '../../../Constants/HomePage';
import { getViewsText } from '../../../Utils/ContentUtils';
import { getFirebaseLiveData } from '../../../Utils/firebaseLiveData';
//import { getValues } from "../../../Utils/firebaseLiveData";
import {
  getContentType,
  getVideoThumbnail,
  isIOSAppUser,
  removeDefaultParams,
} from '../../../Utils/helper';
import { getRouterLocale } from '../../../Utils/i18Utils/constant';
import { iosOpenArticleDetailPage } from '../../../Utils/IosUtils';
import { getSearchParams } from '../common';
import {
  Content,
  PlayButton,
  SimilarVideosCard,
  SimilarVideoThumbnail,
  SimilarVideoThumbnailDiv,
  SimilarVideoThumbnailImg,
  VideoDescriptionContainer,
  VideoTitle,
  Views,
} from './styled';
import { fireClickedCardEvent } from '../../../Utils/useFirebase';

export default function Card(props) {
  const {
    cardData,
    index,
    searchArticle,
    primaryTagId,
    contentType,
    heading,
    readMoreMylo,
    babyNamesArticle,
    id,
    articleId = true,
    parentTag,
    allData,
    lang,
  } = props;
  const router = useRouter();
  const [cardEffect, setCardEffect] = useState(' ');
  const [viewsData, setViewsData] = useState({});
  const viewsValueData = async () => {
    const { getValues } = getFirebaseLiveData();
    const updatedData = await getValues('Views/OwnArticle/', cardData?.id);
    setViewsData(updatedData);
  };
  const ArticleImage =
    cardData?.webpImages?.[0] ||
    cardData?.multiImage?.[0]?.url ||
    allData?.imageUrl ||
    cardData?.files?.[0]?.imageUrl;
  const getTagData = () => {
    let data = '';
    const tagsWithId = cardData?.tagsWithId;
    const primary_tag_id = primaryTagId;
    tagsWithId?.map((element) => {
      if (element?.term_id == primary_tag_id) {
        data = element?.description;
      }
    });
    if (!data) {
      data = cardData?.tagsWithId?.[0]?.description;
    }
    return data;
  };
  useEffect(() => {
    if (cardData?.id) setViewsData(viewsValueData());
  }, [cardData]);
  useEffect(() => {
    setCardEffect('');
  }, [articleId]);

  const iosArticleHandler = () => {
    iosOpenArticleDetailPage(cardData?.id);
  };

  return (
    <Link
      href={{
        pathname: !isIOSAppUser() && cardData?.web_url,
        query: removeDefaultParams(router.query),
      }}
      passHref
      key={id}
      locale={false}
      legacyBehavior
    >
      <SimilarVideosCard
        readMoreMylo={readMoreMylo}
        babyNamesArticle={babyNamesArticle}
        id={id}
        searchArticle={searchArticle}
        className={cardEffect}
        onClick={(e) => {
          e.preventDefault();
          iosArticleHandler();
          setCardEffect('lowOpacity');
          fireClickedCardEvent(
            heading,
            cardData?.title,
            readMoreMylo ? 'article' : getContentType(),
            cardData?.id,
            cardData?.web_url,
            null,
            parentTag,
          );
          setTimeout(() => {
            if (!isIOSAppUser())
              router.push(cardData?.web_url + getSearchParams(), '', {
                locale: getRouterLocale(router),
              });
          }, [200]);
        }}
        as="a"
      >
        <SimilarVideoThumbnail>
          {contentType == '3' ? (
            <SimilarVideoThumbnailImg
              src={getVideoThumbnail(cardData?.url)}
              videoImage={contentType == '3'}
              alt={cardData?.title}
              width="100%"
              loading="lazy"
            />
          ) : (
            // <SimilarVideoThumbnailImg
            //     src={ArticleImage}
            //     srcSet={
            //         ArticleImage
            //             ? `${ArticleImage}?tr=w-140,q-90 140w, ${ArticleImage}?tr=w-400,q-90 400w`
            //             : null
            //     }
            //     sizes={
            //         ArticleImage
            //             ? "(max-width: 720px) 140px, 400px"
            //             : null
            //     }
            //     alt={cardData?.title}
            //     width="100%"
            //     loading="lazy"
            // />

            ArticleImage && (
              <SimilarVideoThumbnailDiv>
                <Image
                  src={ArticleImage}
                  alt={cardData?.title}
                  quality={90}
                  loading={index > 1 ? 'lazy' : 'eager'}
                  fill
                  sizes="33vw"
                />
              </SimilarVideoThumbnailDiv>
            )
          )}

          {contentType == '3' ? (
            <PlayButton>
              <span>
                <img
                  src="/images/playicon.svg"
                  alt="video play"
                  loading="lazy"
                />
              </span>
            </PlayButton>
          ) : null}
        </SimilarVideoThumbnail>
        <VideoDescriptionContainer>
          <VideoTitle>{getTagData()}</VideoTitle>
          <Content>{cardData?.title}</Content>

          <Views>
            {viewsData?.views ? (
              <>
                ({numberWithCommas(viewsData?.views)} {getViewsText(lang)})
              </>
            ) : null}
          </Views>
        </VideoDescriptionContainer>
      </SimilarVideosCard>
    </Link>
  );
}
